import React from 'react';
import Lang from '../../language/services/Lang'
import HrbTranslate from '../../language/HrbTranslate';

const BlockSignalLink = () => (
    <a className='embedded-link' href={Lang.getCurrentValue('App.BlockSignal.Link')} target='_blank' rel='noopener noreferrer'>
        <HrbTranslate text='App.BlockSignal.Text' />
    </a>
);

export default BlockSignalLink;